import React, { useState } from 'react';
import { InputBase, Button, Select, MenuItem } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

const borderColor = 'rgba(0, 0, 0, 0.27)';

const S_Input = ({ width = 206, height = 44, value = '', onChange = () => {}, hint = '請輸入關鍵字', onEnterKey = () => {} }) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  return (
    <InputBase
      style={{
        backgroundColor: 'white',
        width,
        height,
        fontSize: 16,
        letterSpacing: '0.15px',
        borderRadius: 8,
        border: `1px solid ${(over || focus) ? 'black' : borderColor}`,
        paddingLeft: 12,
      }}
      placeholder={hint}
      inputProps={{ height }}
      variant="outlined"
      value={value}
      onChange={e => onChange(e.target.value) }
      onKeyDown={e => { if (e.code === 'Enter') onEnterKey(); }}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      onBlur={() => setFocus(false) }
      onFocus={() => setFocus(true)}
    />
  );
};

const S_Select = ({
  list = [],
  onChange = () => {},
  value = '',
  width = 168,
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);

  return (
    <Select
      style={{
        backgroundColor: 'white',
        width,
        height: 44,
        fontSize: 16,
        letterSpacing: '0.15px',
        borderRadius: 8,
        paddingLeft: 12,
        border: `1px solid ${(over || focus) ? 'black' : borderColor}`,
      }}
      disableUnderline
      displayEmpty
      value={value}
      MenuProps={{ style: { left: -12 } }}
      onChange={e => onChange(e.target.value)}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      onBlur={() => { setFocus(false); setOver(false); } }
      onFocus={() => setFocus(true)}

    >
      <MenuItem value="">請選擇</MenuItem>
      {list.map((o, i) => <MenuItem key={i} value={o.value}>{o.name}</MenuItem>)}
    </Select>
  );
};

const S_Btn_Search = ({ onClick = () => {}, text = '查詢', style = {}, width = 100, height = 44 }) => {
  const [over, setOver] = useState(false);
  const alpha = over ? '80' : '';
  const backgroundColor = `#5597B4${alpha}`;
  return (
    <Button
      style={{ width, height, borderRadius: 8, backgroundColor, color: 'white', transition: 'none', boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)', ...style }}
      onClick={onClick}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
    >
      {text}
    </Button>
  );
};

const S_Btn_Add = ({ onClick = () => {}, text = '＋新增一筆', style = {}, disabled = false }) => {
  const [over, setOver] = useState(false);
  const color = disabled ? 'gray' : over ? 'black' : '#5597B4';
  return (
    <Button
      style={{
        width: 100,
        height: 44,
        borderRadius: 8,
        backgroundColor: disabled ? '#d8d8d8' : 'white',
        color,
        border: `1px solid ${color}`,
        boxShadow: '0px 6px 10px -2px rgba(67, 67, 75, 0.2)',
        transition: 'none',
        ...style,
      }}
      onClick={onClick}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

const S_DateInput = ({
  onChange = () => {},
  value = '',
  error = false,
  height = 44,
  displayBorder = true,
  inputFormat = 'yyyy/MM/dd',
  placeholder = '年 / 月 / 日',
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);
  const views = [];
  if (inputFormat.match('yyyy'))views.push('year');
  if (inputFormat.match('MM'))views.push('month');
  if (inputFormat.match('dd'))views.push('day');
  let mask = inputFormat;
  while (mask.match('y'))mask = mask.replace('y', '_');
  while (mask.match('M'))mask = mask.replace('M', '_');
  while (mask.match('d'))mask = mask.replace('d', '_');

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        {...{ views, inputFormat, mask }}
        value={value}
        onChange={e => onChange(e)}
        onOpen={() => { setFocus(true); setOpen(true); }}
        onClose={() => { setFocus(false); setOpen(false); }}
        open={open}
        renderInput={params => (
          <TextField
            {...params}
            onClick={() => setOpen(true)}
            variant='standard'
            style={{
              backgroundColor: 'white',
              width: 210,
              height,
              textAlign: 'start',
              borderRadius: 8,
              border: (displayBorder || over || focus || error) ? `1px solid ${(over || focus) ? 'black' : (error ? 'red' : borderColor)}` : '',
            }}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              style: { width: 210, height, paddingLeft: 12, paddingRight: 12, fontSize: 16, letterSpacing: '0.15px', color: error ? 'red' : (value !== '' ? 'black' : 'gray'), fontWeight: 500 },
            }}
            inputProps={{
              ...params.inputProps,
              placeholder,
              readOnly: true,
            }}
            onMouseOver={() => setOver(true)}
            onMouseOut={() => setOver(false)}
            onBlur={() => setFocus(false) }
            onFocus={() => setFocus(true)}
          />
        )}
      />
    </LocalizationProvider>
  );
};

const S_LimitDateInput = ({
  onChange = () => {},
  value = '',
  error = false,
  height = 44,
  limit = (date) => { return false; },
  displayBorder = true,
  inputFormat = 'yyyy/MM/dd',
  placeholder = '年 / 月 / 日',
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);
  
  const views = [];
  if (inputFormat.match('yyyy'))views.push('year');
  if (inputFormat.match('MM'))views.push('month');
  if (inputFormat.match('dd'))views.push('day');
  let mask = inputFormat;
  while (mask.match('y'))mask = mask.replace('y', '_');
  while (mask.match('M'))mask = mask.replace('M', '_');
  while (mask.match('d'))mask = mask.replace('d', '_');

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        {...{ views, inputFormat, mask }}
        value={value}
        onChange={e => onChange(e)}
        onOpen={() => { setFocus(true); setOpen(true); }}
        onClose={() => { setFocus(false); setOpen(false); }}
        open={open}
        shouldDisableDate={limit}
        renderInput={params => (
          <TextField
            {...params}
            onClick={() => setOpen(true)}
            variant='standard'
            style={{
              backgroundColor: 'white',
              width: 210,
              height,
              textAlign: 'start',
              borderRadius: 8,
              border: (displayBorder || over || focus || error) ? `1px solid ${(over || focus) ? 'black' : (error ? 'red' : borderColor)}` : '',
            }}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              style: { width: 210, height, paddingLeft: 12, paddingRight: 12, fontSize: 16, letterSpacing: '0.15px', color: error ? 'red' : (value !== '' ? 'black' : 'gray'), fontWeight: 500 },
            }}
            inputProps={{
              ...params.inputProps,
              placeholder,
              readOnly: true,
            }}
            onMouseOver={() => setOver(true)}
            onMouseOut={() => setOver(false)}
            onBlur={() => setFocus(false) }
            onFocus={() => setFocus(true)}
          />
        )}
      />
    </LocalizationProvider>
  );
};

const S_Title = ({ text = '' }) => <div style={{ marginLeft: 12, fontSize: 16, lineHeight: '24px', letterSpacing: '0.15', color: 'rgba(0, 0, 0, 0.87)', textAlign: 'start' }}>{text}</div>;

export { S_Input, S_Btn_Search, S_Btn_Add, S_Select, S_Title, S_DateInput, S_LimitDateInput };
